function applySubToggle() {
    let subLabel = document.querySelector('label.button--label[for="refill-plan--sub"]');
    if (subLabel) {
        subLabel.click();
        let targetOption = document.querySelector('.refill-item--label[for="refill-product--6610905464934"]');
        if (targetOption) {
            targetOption.click();
        }
    }
}

function initSubToggler() {
    function getCookie(name) {
        let cookies = document.cookie.split(";");
        for (let i = 0; i < cookies.length; i++) {
          let cookie = cookies[i].trim();
          let cookieNameValue = cookie.split("=");
          if (cookieNameValue[0] === name) {
            return cookieNameValue[1];
          }
        }
        return null;
      }
      
      let sourceValues = getCookie("_shopify_sa_p");

      function parseUtmData(values) {
        let sourceJson = {};
        let sourceData = values.split('%26');
        for (let i = 0; i < sourceData.length; i++) {
            let keyVal = sourceData[i];
            let splitKeyVal = keyVal.split('%3D');
            let key = splitKeyVal[0];
            let value = splitKeyVal[1];
            sourceJson[key] = value
        }
        if (sourceJson.utm_source === 'facebook' && sourceJson.utm_content === 'subscription') {
            applySubToggle()
        }
      }
      
      if (sourceValues) {
        parseUtmData(sourceValues);
      }
}

document.addEventListener('DOMContentLoaded', initSubToggler)